"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowRight, Mail, Phone, Wrench } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Contactcta() {
  const shouldReduceMotion = useReducedMotion();
  const containerVariants = {
    hidden: {
      opacity: 0,
      y: shouldReduceMotion ? 0 : 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: "easeOut"
      }
    }
  };
  return <section id="contactcta" data-nav="light" className="relative overflow-hidden bg-background py-20 md:py-28">
      {/* Decorative subtle background elements */}
      <div className="pointer-events-none absolute inset-0 -z-10 flex items-center justify-center opacity-40">
        <div className="h-[420px] w-[420px] rounded-full bg-accent/40 blur-3xl" />
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.3
      }} className="relative mx-auto max-w-4xl overflow-hidden rounded-2xl border border-border bg-card p-8 shadow-xl md:p-14">
          {/* Subtle industrial pattern accent */}
          <div className="absolute top-0 right-0 h-32 w-32 translate-x-8 -translate-y-8 rounded-full bg-primary/5 blur-2xl" />

          <div className="relative z-10 text-center">
            <div className="mx-auto mb-6 inline-flex items-center gap-2 rounded-full border border-border bg-muted/60 px-4 py-1.5 text-xs font-medium text-muted-foreground">
              <Wrench className="size-3.5 text-secondary" />
              <span>Engenharia e pulverização industrial</span>
            </div>

            <h2 className="font-default text-3xl font-semibold tracking-tight text-card-foreground sm:text-4xl">
              Tem um desafio técnico no seu processo industrial?
            </h2>

            <p className="mx-auto mt-4 max-w-2xl text-base text-muted-foreground sm:text-lg">
              Fale com a nossa equipa de especialistas. Analisamos a sua aplicação e apresentamos a tecnologia de pulverização mais eficiente para o seu processo.
            </p>

            <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row">
              <Button asChild size="lg" className="gap-2 px-8 shadow-md">
                <Link to="/ContactsPage">
                  <span>Contacte-nos</span>
                  <ArrowRight className="size-4" />
                </Link>
              </Button>
            </div>

            {/* Quick contact hints */}
            <div className="mt-10 grid grid-cols-1 gap-4 border-t border-border pt-8 sm:grid-cols-2 text-left">
              <div className="flex items-center gap-3 rounded-lg border border-border/60 bg-muted/30 p-3">
                <div className="flex size-9 shrink-0 items-center justify-center rounded-md bg-secondary/10 text-secondary">
                  <Phone className="size-4" />
                </div>
                <div>
                  <p className="text-xs font-medium text-muted-foreground">Apoio técnico dedicado</p>
                  <p className="text-sm font-semibold text-foreground">Representante Spraying Systems Co.</p>
                </div>
              </div>

              <div className="flex items-center gap-3 rounded-lg border border-border/60 bg-muted/30 p-3">
                <div className="flex size-9 shrink-0 items-center justify-center rounded-md bg-secondary/10 text-secondary">
                  <Mail className="size-4" />
                </div>
                <div>
                  <p className="text-xs font-medium text-muted-foreground">Resposta rápida</p>
                  <p className="text-sm font-semibold text-foreground">Propostas e orçamentos técnicos</p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}